import React from 'react';
import {
  CrmAcquisitionIcon,
  CrmAnnouncementIcon,
  CrmQuoteRequestIcon,
} from '../pages/svg/svgIcons';

const CRM_TYPE_ICON_MAP = {
  announcement: CrmAnnouncementIcon,
  notice: CrmAnnouncementIcon,
  acquisition: CrmAcquisitionIcon,
  quote_request: CrmQuoteRequestIcon,
  inquiry: CrmQuoteRequestIcon,
};

const CRM_TYPE_LABEL_KEYS = {
  announcement: 'CrmCommunication.Type.announcement',
  notice: 'CrmCommunication.Type.announcement',
  acquisition: 'CrmCommunication.Type.acquisition',
  quote_request: 'CrmCommunication.Type.quote_request',
  inquiry: 'CrmCommunication.Type.quote_request',
};

export const CRM_COMMUNICATION_TYPE_FILTER_VALUES = ['announcement', 'acquisition', 'quote_request'];

export function crmCommunicationTypeLabelKey(ticketType) {
  const type = String(ticketType || '').trim();
  return CRM_TYPE_LABEL_KEYS[type] || CRM_TYPE_LABEL_KEYS.announcement;
}

export function isKnownCrmCommunicationType(ticketType) {
  const type = String(ticketType || '').trim();
  return Object.prototype.hasOwnProperty.call(CRM_TYPE_LABEL_KEYS, type);
}

export function renderCrmCommunicationTypeIcon(ticketType, { width = 6, height = 6, title } = {}) {
  const type = String(ticketType || '').trim();
  const Icon = CRM_TYPE_ICON_MAP[type] || CrmAnnouncementIcon;
  const icon = <Icon width={width} height={height} />;
  if (!title) return icon;
  return (
    <span className="inline-flex items-center justify-center" title={title}>
      {icon}
    </span>
  );
}

export const CRM_COMMUNICATION_HUB_TYPE_ITEMS = [
  {
    index: 0,
    ticketType: 'announcement',
    tabNameKey: 'CrmCommunicationNewTaskHub.Tab.Announcement',
    introKey: 'CrmCommunication.Form.Intro.announcement',
    icon: CrmAnnouncementIcon,
  },
  {
    index: 1,
    ticketType: 'acquisition',
    tabNameKey: 'CrmCommunicationNewTaskHub.Tab.Acquisition',
    introKey: 'CrmCommunication.Form.Intro.acquisition',
    icon: CrmAcquisitionIcon,
  },
  {
    index: 2,
    ticketType: 'quote_request',
    tabNameKey: 'CrmCommunicationNewTaskHub.Tab.QuoteRequest',
    introKey: 'CrmCommunication.Form.Intro.quote_request',
    icon: CrmQuoteRequestIcon,
  },
];
